import React, { useEffect, useState } from "react";
import { Form, Input, Select, message } from "antd";
import FormModal from "../../../components/FormModal";
import PasswordFields from "../../../components/PasswordFields";
import { extractMsg } from "../../../utils/errorUtils";

export function AddUserDialog({ open, onClose, onSave }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await onSave(values);
      form.resetFields();
      onClose();
    } catch (error) {
      message.error(extractMsg(error, "Failed to add user"));
      console.error("Failed to add user:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormModal
      title="Add New User"
      open={open}
      onClose={() => {
        form.resetFields();
        onClose();
      }}
      onFinish={handleFinish}
      loading={loading}
      form={form}
      initialValues={{ role: "VIEWER" }}
    >
      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true, type: "email" }]}
      >
        <Input placeholder="Enter email address" />
      </Form.Item>
      <Form.Item
        name="username"
        label="Username"
        rules={[{ required: true, min: 6, max: 24 }]}
      >
        <Input placeholder="Enter username" />
      </Form.Item>
      <PasswordFields />
      <Form.Item name="role" label="Role" rules={[{ required: true }]}>
        <Select placeholder="Select a role">
          <Select.Option value="VIEWER">Viewer</Select.Option>
          <Select.Option value="ANALYST">Analyst</Select.Option>
        </Select>
      </Form.Item>
    </FormModal>
  );
}

export function EditRoleDialog({ open, user, onClose, onSave }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && user) form.setFieldsValue({ role: user.role });
  }, [open, user, form]);

  const handleFinish = async (values) => {
    setLoading(true);
    try {
      await onSave(user.id, values.role);
      onClose();
    } catch (error) {
      message.error(extractMsg(error, "Failed to update role"));
      console.error("Failed to update role:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormModal
      title="Edit User Role"
      open={open}
      onClose={onClose}
      onFinish={handleFinish}
      loading={loading}
      form={form}
    >
      <Form.Item name="role" label="Role" rules={[{ required: true }]}>
        <Select placeholder="Select a role">
          <Select.Option value="VIEWER">Viewer</Select.Option>
          <Select.Option value="ANALYST">Analyst</Select.Option>
        </Select>
      </Form.Item>
    </FormModal>
  );
}
